import styled, { keyframes } from "styled-components";
import { media } from "../../pages/Kanban/styles/breakpoints";

interface IRoutesContainerToMobile {
  isOpen: boolean;
}

type ICoordinates = {
  top?: string;
  left?: string;
  right?: string;
};

export const Container = styled.div`
  width: 100%;
  background: transparent;
  border-bottom: 0;

  ${media.tabletOnly} {
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }
`;

export const Content = styled.header`
  max-width: 1680px;
  width: calc(100% - 32px);
  box-sizing: border-box;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 8px auto;
  border: 1px solid rgba(226, 232, 240, 0.92);
  border-radius: 16px;
  background-color: ${(props) => props.theme.colors.headerBackground};
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.055);

  > a {
    > img {
      height: 26px;
      filter: ${(props) =>
        props.theme.mode === "dark"
          ? "invert(1) grayscale(1) brightness(2)"
          : "none"};
    }
  }

  @media (max-width: 767px) {
    width: calc(100% - 20px);
    max-width: 100%;
    padding: 14px 16px;
    margin: 10px auto;

    > a {
      > img {
        height: 22px;
      }
    }
  }

  ${media.tabletOnly} {
    max-width: 100%;
    width: calc(100% - 24px);
    padding: 12px 16px;
    box-sizing: border-box;
    overflow: visible;

    > a {
      > img {
        height: 20px;
        max-width: 100%;
      }
    }
  }
`;

export const OptionButton = styled.button`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  border: 0;
  background-color: transparent;
  margin: 0 8px;
  position: relative;
  > a {
    font-size: 13px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.headerText};
  }

  > p {
    color: ${(props) => props.theme.colors.headerText};
    font-size: 13px;
    font-weight: 600;
  }

  .notification-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #bf0000;
    margin-left: 6px;
    display: inline-block;
  }

  > svg {
    margin-left: 4px;
  }

  ${media.tabletOnly} {
    margin: 0 4px;
    min-width: 0;

    > a,
    > p {
      font-size: 13px;
      line-height: 1.2;
      max-width: 100%;
      white-space: normal;
      overflow-wrap: break-word;
      word-break: break-word;
    }

    .notification-dot {
      width: 6px;
      height: 6px;
      margin-left: 4px;
    }
  }
`;

export const MoreOptionsOptionsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${(props) => props.theme.colors.headerText};
  padding: 8px 16px;
  background-color: transparent;
  border: 0;
  width: 100%;
  cursor: pointer;
  text-align: left;

  > p {
    margin: 0;
    font-size: 13px;
    font-weight: 400;
    white-space: nowrap;
  }

  a {
    font-size: 13px;
    font-weight: 400;
  }

  > svg {
    margin-left: 4px;
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.dropdownHover};
  }

  ${media.tabletOnly} {
    padding: 6px 12px;

    a {
      font-size: 13px;
      line-height: 1.2;
      max-width: 100%;
      white-space: normal;
      overflow-wrap: break-word;
    }

    > p {
      font-size: 13px;
    }
  }
`;

export const MoreOptionsOptionsContainer = styled.div`
  position: relative;
`;

export const OptionsToRouteContainer = styled.div<ICoordinates>`
  position: absolute;
  top: ${({ top }) => top ?? "calc(100% + 8px)"};
  left: ${({ left }) => left ?? "0"};
  right: ${({ right }) => right ?? "auto"};
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.dropdownBackground};
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.09);
  min-width: 200px;
  padding: 8px 0;

  &::before {
    content: "";
    position: absolute;
    top: -9px;
    left: 0;
    right: 0;
    height: 9px;
  }

  > a,
  .report-modal-btn {
    color: ${(props) => props.theme.colors.headerText};
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    white-space: nowrap;
    text-decoration: none;
    transition: background-color 0.2s;
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      background-color: ${(props) => props.theme.colors.dropdownHover};
    }
  }

  .offers-count {
    background: #bf0000;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    margin-left: 12px;
    min-width: 20px;
    text-align: center;
    height: 20px;
    padding: 0 6px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .board-link {
    padding: 10px 20px;
    font-size: 14px;
    white-space: nowrap;
  }

  ${media.tabletOnly} {
    min-width: 180px;
    max-width: 90vw;
    left: ${({ left }) => left ?? "auto"};
    right: ${({ right, left }) => right ?? (left ? "auto" : "0")};

    > a,
    .report-modal-btn {
      padding: 10px 12px;
      font-size: 13px;
      white-space: normal;
      word-break: break-word;
    }

    .offers-count {
      font-size: 10px;
      min-width: 18px;
      height: 18px;
      margin-left: 8px;
    }

    .board-link {
      padding: 10px 12px;
      font-size: 13px;
    }
  }

  @media (max-width: 767px) {
    min-width: 160px;
    max-width: 85vw;

    > a,
    .report-modal-btn {
      padding: 12px 16px;
      font-size: 14px;
    }
  }
`;

export const RoutesContainer = styled.nav`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .username {
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
    font-size: 13px;
    margin: 0 8px;
  }

  .sign-out-button {
    margin-left: 14px;
    color: #dd6435;
    font-size: 13px;
    font-weight: 500;
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 14px;
  }

  @media (max-width: 767px) {
    display: none;
  }

  ${media.tabletOnly} {
    min-width: 0;
    max-width: 100%;
    overflow: visible;
    gap: 2px;

    .username {
      font-size: 13px;
      line-height: 1.2;
      max-width: 100%;
      white-space: normal;
      overflow-wrap: break-word;
    }

    > button {
      margin-left: 6px;
    }

    .sign-out-button {
      margin-left: 6px;
      font-size: 12px;
    }
  }
`;

export const MenuButton = styled.button`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    margin-left: auto;
    background-color: transparent;
  }
`;

const openMenu = keyframes`
  from {
    height: 0px;
  }

  to {
    height: 100%;
  }
`;

const closeMenu = keyframes`
  from {
    height: 100%;
  }

  to {
    height: 0px;
  }
`;

export const RoutesContainerToMobile = styled.div<IRoutesContainerToMobile>`
  display: none;
  background-color: ${(props) => props.theme.colors.headerBackground};

  @media (max-width: 767px) {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 12px;
    animation: ${(props) => (!!props.isOpen ? openMenu : closeMenu)} 100s;

    > a {
      font-size: 15px;
      color: ${(props) => props.theme.colors.headerText};

      & + a {
        margin-top: 14px;
      }
    }

    .sign-out-button {
      font-size: 15px;
      color: ${(props) => props.theme.colors.headerText};
      margin-top: 14px;
      padding: 10px 12px;
      border: 1px solid ${(props) => props.theme.colors.headerText};
      border-radius: 4px;
      background-color: transparent;
      transition: all 0.2s;

      &:hover {
        background-color: ${(props) => props.theme.colors.headerText};
        color: ${(props) => props.theme.colors.headerBackground};
      }
    }
  }
`;
